import {faker}  from "@faker-js/faker";
import { getAccounts } from "../helpers/get-accounts";
import defaultValuesOld from "../scenarios/edu-scenarios";
import {
  PERIOD_TYPE_DAILY,
  PERIOD_TYPE_MONTHLY,
} from "../../utils/app-constants.json";

const reports = [
  {
    RequestedDate: "2019-05-16 06:13:52",
    ReportType: "Compliance Summary",
    CompliancePercentage: 96,
    Filters: {
      Date: "2019-05-16",
    },
  },
  {
    RequestedDate: "2019-04-24 08:50:08",
    ReportType: "Patch Summary",
    CompliancePercentage: 100.0,
    Filters: {
      Date: "2019-04-24",
      PatchBaselineNames: [
        {
          BaselineDescription: "Default Patch Baseline Provided by AWS.",
          BaselineId:
            "arn:aws:ssm:us-east-2:733109147000:patchbaseline/pb-020d361a05defe4ed",
          BaselineName: "AWS-DefaultPatchBaseline",
          OperatingSystem: "WINDOWS",
          Owner: "AWS",
        },
      ],
    },
  },
  {
    RequestedDate: "2019-04-24 08:50:37",
    ReportType: "Applications Compliance",
    CompliancePercentage: 100.0,
    Filters: {
      Date: "2019-04-24",
      PatchGroups: ["HR"],
    },
  },
  {
    RequestedDate: "2019-04-24 08:50:37",
    ReportType: "Zero-day Vulnerability Compliance",
    CompliancePercentage: 100.0,
    Filters: {
      Date: "2019-04-24",
      PatchGroups: ["HR"],
    },
  },
  {
    RequestedDate: "2019-04-24 08:50:37",
    ReportType: "KB Article/CVE Level Reporting",
    CompliancePercentage: 100.0,
    Filters: {
      Date: "2019-04-24",
      PatchGroups: ["HR"],
    },
  },
];

export const allReports = () => {
  return reports;
};

var os = defaultValuesOld().os;

var regionCodes = [
  "us-east-1",
  "us-east-2",
  "us-west-1",
  "us-west-2",
  "ap-south-1",
];

export const reportDetails = async () => {
  const instances = [];
  let accounts = await getAccounts();
  for (var i = 0; i < 50; i++) {
    var instance = {
      AccountNumber: faker.helpers.arrayElement(accounts),
      RegionCode: faker.helpers.arrayElement(regionCodes),
      PatchBaselineId: `pb-${faker.random.alphaNumeric(15)}`,
      OperationStartTime: "2019-01-12T04:03:49Z",
      ExecutionTime: "2019-01-12T04:03:49Z",
      resourceId: `i-${faker.random.alphaNumeric(15)}`,
      ExecutionType: "Command",
      PatchGroup: "PayrollApp",
      captureTime: "2019-01-12T04:03:57Z",
      OperatingSystem: faker.helpers.arrayElement(os).toUpperCase(),
      CompliantCriticalCount: 0,
      Status: faker.helpers.arrayElement(["COMPLIANT", "NON_COMPLIANT"]),
      NonCompliantCriticalCount: 0,
      CompliantInformationalCount: 0,
      NonCompliantMediumCount: 0,
      Tags: [
        {
          Value: "PayrollApp_AMAZON_LINUX_2",
          Key: "MontyCloudServerGroupName",
        },
        {
          Value: "ce74cf41-4a96-4565-a396-dd9e740babaf",
          Key: "MontyCloudTagId",
        },
        {
          Value: "PayrollApp",
          Key: "Patch Group",
        },
        {
          Value: "09ccbd68-98db-4c5a-a847-0cf5e2b81caf",
          Key: "MontyCloudInventoryId",
        },
        {
          Value: faker.helpers.arrayElement(os),
          Key: "Name",
        },
      ],
      MissingCount: 0,
      CompliantHighCount: 0,
      NotApplicableCount: 206,
      NonCompliantUnspecifiedCount: 0,
      ExecutionId: "8d7cc78b-7863-4f42-b12b-7ceb83852231",
      InstalledRejectedCount: 0,
      NonCompliantInformationalCount: 0,
      SnapshotId: "8d7cc78b-7863-4f42-b12b-7ceb83852231",
      InstalledCount: 15,
      NonCompliantHighCount: 0,
      FailedCount: 0,
      CompliantMediumCount: 0,
      CompliantLowCount: 0,
      OperationType: faker.helpers.arrayElement(["Install", "Scan"]),
      CompliantUnspecifiedCount: 429,
      OverallSeverity: "UNSPECIFIED",
      NonCompliantLowCount: 0,
      ComplianceType: "Patch",
      OperationEndTime: "2019-01-12T04:03:52Z",
      InstalledOtherCount: 414,
      PatchBaselineName: "AWS-AmazonLinux2DefaultPatchBaseline",
    };
    instances.push(instance);
  }
  return {
    Summary: [
      {
        Date: "2018-12-06T12:33:35Z",
        TotalInstanceCount: 50,
        CompliantInstanceCount: 48,
        NonComplianceInstanceCount: 1,
        UnknownStatusCount: 1,
        TotalWindowsCount: 20,
        TotalLinuxCount: 30,
        CompliancePercentage: "96",
      },
    ],
    InstanceData: instances,
  };
};

export const getReportExports = () => {
  const items = [
    {
      ReportId: 1,
      ReportType: "SecurityBotReport",
      Status: "Success",
      CreatedAt: faker.date.past(),
      ExportFormat: "PDF",
    },
    {
      ReportId: 2,
      ReportType: "ComplianceBotReport",
      Status: "Success",
      CreatedAt: faker.date.past(),
      ExportFormat: "JSON",
    },
    {
      ReportId: 3,
      ReportType: "CostOptimization",
      Status: "Success",
      CreatedAt: faker.date.past(),
      ExportFormat: "CSV_DATA",
    },
    {
      ReportId: 4,
      ReportType: "CostSummary",
      Status: "Success",
      CreatedAt: faker.date.past(),
      Filters: {
        Granularity: PERIOD_TYPE_DAILY,
      },
      ExportFormat: "CSV_DATA",
    },
    {
      ReportId: 5,
      ReportType: "CostSummary",
      Status: "Success",
      CreatedAt: faker.date.past(),
      Filters: {
        Granularity: PERIOD_TYPE_MONTHLY,
      },
      ExportFormat: "CSV_DATA",
    },
    {
      ReportId: 6,
      ReportType: "InventorySummary",
      Status: "Success",
      CreatedAt: faker.date.past(),
      ExportFormat: "JSON",
    },
  ];
  return items;
};
